import { ITributoPossivel, ITributos } from 'interfaces/ITributos';
import {
  IReceitaExportacoesNCMEnviar,
  IReceitaExportacoesVinculadaNCMEnviar,
} from '../../../../../../../../../../../interfaces/IReceitaExportacoes';
import { removeFormatCurrency } from '../../../../../../../../../../../utils/formatCurrency';
import { validarDeducoes, validarTributosExportacaoEConsumo } from 'utils/validarDeducoes';

const NUMERO_MINIMO = 0.01;
const NUMERO_MAXIMO = 1e11;

const validarCampoTexto = (value?: string): boolean => {
  return value == undefined || value === '';
};

const validarCampoNumero = (value?: string) => {
  if (value) {
    const floatValue = parseFloat(value);
    return floatValue < NUMERO_MINIMO || floatValue >= NUMERO_MAXIMO;
  } else {
    return true;
  }
};

const validarCampoFinanceiro = (value?: string) => {
  return value == undefined || removeFormatCurrency(value) < NUMERO_MINIMO;
};

const retornarCamposObrigatorios = (
  formValues: IReceitaExportacoesVinculadaNCMEnviar | IReceitaExportacoesNCMEnviar
) => {
  const CAMPOS_BASE = [
    { field: 'codigoNcm', label: 'Código NCM do Bem Mineral' },
    { field: 'unidadeMedida', label: 'Unidade de Medida' },
    { field: 'quantidade', label: 'Quantidade', validate: validarCampoNumero },
    { field: 'valorTotalOperacao', label: 'Total da Operação', validate: validarCampoFinanceiro },
  ];

  const CAMPOS_SEM_VINCULO = [
    { field: 'valorProducaoTotal', label: 'Valor de Produção (VP)', validate: validarCampoFinanceiro },
    { field: 'teorConcentrado', label: 'Teor Concentrado (TC)', validate: validarCampoNumero },
    { field: 'teorAlimentacao', label: 'Teor Alimentação (TA)', validate: validarCampoNumero },
  ];

  const CAMPOS_COM_VINCULO = [
    { field: 'nomeMetodoApuracaoPreco', label: 'Método para Apuração do Preço' },
    { field: 'precoParametro', label: 'Preço Parâmetro', validate: validarCampoFinanceiro },
  ];

  const camposObrigatorios = [...CAMPOS_BASE];

  if (formValues.hasExportacao) {
    camposObrigatorios.push(...CAMPOS_COM_VINCULO);
  } else {
    camposObrigatorios.push(...CAMPOS_SEM_VINCULO);
  }

  return camposObrigatorios;
};

const validarCamposObrigatorios = (
  formValues: IReceitaExportacoesVinculadaNCMEnviar | IReceitaExportacoesNCMEnviar,
  tributosPossiveis: ITributos | undefined,
  substanciaFatorAjusteId?: string
) => {
  const camposObrigatorios = retornarCamposObrigatorios(formValues);

  const camposInvalidos = [];

  for (const campo of camposObrigatorios) {
    let testeValidacao = validarCampoTexto;

    if (campo.validate) {
      testeValidacao = campo.validate;
    }

    if (testeValidacao((formValues as any)[campo.field])) {
      camposInvalidos.push(campo.label);
    }
  }

  if (substanciaFatorAjusteId === '') {
    camposInvalidos.push('Substância para Fator de Ajuste');
  }

  let errosValidacaoDeducoes = validarDeducoes(formValues.tributosValores, tributosPossiveis);
  if (errosValidacaoDeducoes !== '') {
    return errosValidacaoDeducoes;
  }

  if (camposInvalidos.length === camposObrigatorios.length + 1) {
    return 'Por favor, preencha corretamente todos os campos';
  } else if (camposInvalidos.length >= 2) {
    return `Por favor, preencha corretamente os campos "${camposInvalidos[0]}" e "${camposInvalidos[1]}"`;
  } else if (camposInvalidos.length == 1) {
    return `Por favor, preencha corretamente o campo "${camposInvalidos[0]}"`;
  } else {
    return '';
  }
};

const validarCompraTerceiro = (
  formValues: IReceitaExportacoesVinculadaNCMEnviar | IReceitaExportacoesNCMEnviar,
  haCompraTerceiro: boolean
) => {
  if (haCompraTerceiro) {
    if (
      validarCampoNumero(formValues.quantidadeAquisicaoTerceiros.toString()) ||
      validarCampoFinanceiro(formValues.valorAquisicaoTerceiros.toString())
    ) {
      return 'Você informou que há compra de terceiro. Por favor, informe a quantidade e o valor de aquisição de terceiros.';
    }

    if (formValues.valorTotalOperacao < formValues.valorAquisicaoTerceiros) {
      return 'O valor total de aquisição de terceiros não pode ser maior que o valor total da operação.';
    }

    return '';
  } else {
    return '';
  }
};

export const validarReceitaCalculadaExportacoes = (
  formValues: IReceitaExportacoesVinculadaNCMEnviar | IReceitaExportacoesNCMEnviar,
  haCompraTerceiro: boolean,
  tributosPossiveis: ITributos | undefined,
  substanciaFatorAjusteId?: string
) => {
  const msgCamposObrigatorios = validarCamposObrigatorios(formValues, tributosPossiveis, substanciaFatorAjusteId);
  const msgCompraTerceiro = validarCompraTerceiro(formValues, haCompraTerceiro);

  if (msgCamposObrigatorios !== '') {
    return msgCamposObrigatorios;
  }

  if (msgCompraTerceiro !== '') {
    return msgCompraTerceiro;
  }

  return '';
};
